module.exports = "https://bin.bnbstatic.com/_next/static/images/NPXS_app-CN-c8024cd14e017433b4b2027b4b9a05f6.jpg";